import { Button, Card, CardBody, CardTitle, Popover, Typography, } from '@one-thd/sui-atomic-components';
import { ErrorFilled } from '@one-thd/sui-icons';
import React, { useState, useEffect } from 'react';
import { FetchSpendAcrossAccounts } from '../../hooks/linked-accounts';
import { B2B_DOWNLOADS_LINK } from '../../constants/links';
import { SpendAcrossAccountsSkeleton } from './LinkedAccountsSkeleton';
import { floorNumberWithCommas } from '../../utils/currency-utils';
import { clearRedirectFlags } from '../../utils/linked-accounts';
import { getSvocId } from '../../utils/user';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import ExportLinkedAccountsHistory from './ExportLinkedAccountsHistory';
import '../../styles/linked-accounts.scss';
var renderWarningMessage = function () {
    return (React.createElement("div", { className: "sui-inline-flex", style: { paddingLeft: 10 } },
        React.createElement(ErrorFilled, { color: "warning" }),
        React.createElement("p", { style: { paddingTop: 5, color: '#8f6e2e' } },
            React.createElement("b", null, "Warning!"),
            " Some of the information my not be available. Please try again later.")));
};
var renderProXtraImg = function (isProRewards) {
    return isProRewards ? (React.createElement("div", { style: { paddingRight: '50px' } },
        React.createElement("img", { height: 120, width: 120, alt: "pro-extra-preferred", src: "https://assets.thdstatic.com/images/v1/PRO-Extra-logo.svg" }))) : (React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/ProPaintRewardsIcon.svg", alt: "ProPaint Rewards Icon", width: "160px", height: "70px" }));
};
var getCardTotalElement = function (value) {
    return (React.createElement(Typography, { variant: "body-base", weight: "bold" },
        React.createElement("div", { className: "sui-inline-flex" },
            React.createElement("span", { className: "sui-relative", style: { top: 5 } }, "$"),
            React.createElement("p", { style: { fontSize: 25 } }, value))));
};
var renderSpendAcrossAcctCard = function (title, value, isProRewards) {
    return (React.createElement("div", { className: "sui-grow" },
        React.createElement(Card, { className: "sui-w-full" },
            React.createElement(CardTitle, { header: title }),
            React.createElement(CardBody, null,
                React.createElement("div", { className: "sui-flex sui-justify-between", style: { height: 55 } },
                    renderProXtraImg(isProRewards),
                    getCardTotalElement(value))))));
};
var downloadConfigElement = function (renderDownloadConfig, setRenderDownloadCongif, hierarchyName) {
    return (React.createElement("div", { className: "sui-grid sui-justify-between sm:sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-2", style: { paddingBottom: 5 } },
        React.createElement(Typography, { variant: "h3" }, hierarchyName),
        !renderDownloadConfig && (React.createElement("div", { className: "sui-flex sui-justify-end" },
            React.createElement("div", { className: "sui-self-center", style: { paddingRight: 5 } }, "Download Purchase History CSV"),
            React.createElement("div", { className: "sui-self-center" },
                React.createElement(Button, { variant: "secondary", onClick: function () { return setRenderDownloadCongif(true); } }, "Download"))))));
};
var helpPopover = function (handleClose, anchorElement, open) { return (React.createElement(Popover, { anchorEl: anchorElement, id: "right-popover", open: open, onClose: handleClose, placement: "right", title: "Tracking Spend Across Accounts", offset: "loose", "data-testid": "help-popover" },
    React.createElement(Typography, { variant: "body-xs" },
        "Includes transactions made with Pro Xtra ID or registered tender. Excludes taxes, shipping fees, returns, and gift card purchases. ",
        React.createElement("br", null),
        React.createElement("br", null),
        "For full details, see the",
        ' ',
        React.createElement("a", { href: "https://www.homedepot.com/c/ProXtra_TermsandConditions", style: { color: '#3E7697' } }, "Pro Xtra Program Terms & Conditions")))); };
var createCurrentSpendCard = function (totalSpend) {
    var title = '';
    var value = '';
    if (totalSpend) {
        totalSpend.forEach(function (spend) {
            if (spend.programDescription === 'PRO XTRA') {
                spend.yearlySpend.forEach(function (yearly) {
                    if (yearly.isCurrentYear) {
                        title = "".concat(yearly.year, " Spend Across Accounts");
                        value = floorNumberWithCommas(yearly.spend, 0);
                    }
                });
            }
        });
    }
    return renderSpendAcrossAcctCard(title, value, true);
};
var createCurrentPaintSpendCard = function (totalSpend) {
    var title = '';
    var value = '';
    if (totalSpend) {
        totalSpend.forEach(function (spend) {
            if (spend.programDescription === 'PRO XTRA PAINT REWARDS') {
                spend.yearlySpend.forEach(function (yearly) {
                    if (yearly.isCurrentYear) {
                        title = "".concat(yearly.year, " Paint Spend Across Accounts");
                        value = floorNumberWithCommas(yearly.spend, 0);
                    }
                });
            }
        });
    }
    return renderSpendAcrossAcctCard(title, value, false);
};
var createPastSpendCard = function (totalSpend) {
    var title = '';
    var value = '';
    if (totalSpend) {
        totalSpend.forEach(function (spend) {
            if (spend.programDescription === 'PRO XTRA') {
                spend.yearlySpend.forEach(function (yearly) {
                    if (!yearly.isCurrentYear) {
                        title = "".concat(yearly.year, " Spend Across Accounts");
                        value = floorNumberWithCommas(yearly.spend, 0);
                    }
                });
            }
        });
    }
    return renderSpendAcrossAcctCard(title, value, true);
};
var handleApiDataResponse = function (spendAcrossAccountsData, spendAcrossAccountsError, spendAcrossAccountsLoaded) {
    if (spendAcrossAccountsLoaded) {
        if (spendAcrossAccountsError && spendAcrossAccountsData === null) {
            renderWarningMessage();
        }
        return (React.createElement("div", { className: "sui-grid md:sui-grid-cols-1 lg:sui-grid-cols-3 sui-gap-6", style: { paddingTop: 10 } },
            createCurrentSpendCard(spendAcrossAccountsData === null || spendAcrossAccountsData === void 0 ? void 0 : spendAcrossAccountsData.totalSpend),
            createCurrentPaintSpendCard(spendAcrossAccountsData === null || spendAcrossAccountsData === void 0 ? void 0 : spendAcrossAccountsData.totalSpend),
            createPastSpendCard(spendAcrossAccountsData === null || spendAcrossAccountsData === void 0 ? void 0 : spendAcrossAccountsData.totalSpend)));
    }
    return React.createElement(SpendAcrossAccountsSkeleton, null);
};
var SpendAcrossAccountElement = function (props) {
    var hierarchyName = props.hierarchyName;
    var _a = useState(false), renderDownloadConfig = _a[0], setRenderDownloadCongif = _a[1];
    var _b = useState(null), anchorElement = _b[0], setAnchorElement = _b[1];
    var handleClick = function (event) {
        setAnchorElement(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorElement(null);
    };
    var open = Boolean(anchorElement);
    var request = {
        totalSpendRequest: {
            customerAccountId: getSvocId() || '',
        },
    };
    var _c = FetchSpendAcrossAccounts(request), spendAcrossAccountsData = _c.spendAcrossAccountsData, spendAcrossAccountsError = _c.spendAcrossAccountsError, spendAcrossAccountsLoaded = _c.spendAcrossAccountsLoaded;
    useEffect(function () {
        return function () { return clearRedirectFlags(); };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionHeader, { title: "Spend Across Accounts", toolTipComponent: helpPopover(handleClose, anchorElement, open), handleClick: handleClick },
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                React.createElement("a", { href: B2B_DOWNLOADS_LINK, className: "sui-self-end downloadsLink" }, "View Past Downloads"))),
        downloadConfigElement(renderDownloadConfig, setRenderDownloadCongif, hierarchyName),
        renderDownloadConfig && (React.createElement(ExportLinkedAccountsHistory, { setRenderDownloadCongif: setRenderDownloadCongif })),
        handleApiDataResponse(spendAcrossAccountsData, spendAcrossAccountsError, spendAcrossAccountsLoaded)));
};
export default SpendAcrossAccountElement;
